import { getHostContext } from './hostContext'

const LOCAL_API_BASE_URL = 'http://slacklinetjs.local/api'
const LOCAL_API_ROOT_URL = 'http://slacklinetjs.local'

function isLocalUrl(url = '') {
  try {
    const parsed = new URL(url)
    const host = parsed.hostname || ''
    return host === 'localhost' || host.endsWith('.local')
  } catch {
    return false
  }
}

export function resolveApiBaseUrl() {
  const configuredBaseUrl = (process.env.VUE_APP_API_BASE_URL || '').trim()
  const { env } = getHostContext()

  if (env === 'staging') {
    return 'https://test.slackline-tjs.com/api'
  }

  if (env === 'prod') {
    return 'https://slackline-tjs.com/api'
  }

  if (configuredBaseUrl && (env === 'local' || !isLocalUrl(configuredBaseUrl))) {
    return configuredBaseUrl
  }

  if (env === 'local') {
    return configuredBaseUrl || LOCAL_API_BASE_URL
  }

  if (configuredBaseUrl) {
    return configuredBaseUrl
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`
  }

  return LOCAL_API_BASE_URL
}

export function resolveApiRootUrl() {
  const configuredRootUrl = (process.env.VUE_APP_API_ROOT_URL || '').trim()
  const apiBaseUrl = resolveApiBaseUrl()

  if (configuredRootUrl && !isLocalUrl(configuredRootUrl)) {
    return configuredRootUrl
  }

  if (apiBaseUrl) {
    return apiBaseUrl.replace(/\/api\/?$/, '')
  }

  if (configuredRootUrl) {
    return configuredRootUrl
  }

  return LOCAL_API_ROOT_URL
}

export function resolveBroadcastAuthUrl() {
  const configuredBroadcastAuthUrl = (process.env.VUE_APP_BROADCAST_AUTH_URL || '').trim()

  if (configuredBroadcastAuthUrl && !isLocalUrl(configuredBroadcastAuthUrl)) {
    return configuredBroadcastAuthUrl
  }

  return `${resolveApiRootUrl()}/broadcasting/auth`
}